
import { defineComponent } from "vue";
import { VTextField } from "vuetify/lib";

export default defineComponent({
  mixins: [VTextField],
  props: {
    clearable: {
      type: Boolean,
      default: true,
    },
    clearIcon: {
      type: String,
      default: "$clear",
    },
  },
});
